import { zodResolver } from "@hookform/resolvers/zod";
import { Box, Grid } from "@mui/material";
import { useCallback, useContext, useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useLoader } from "src/hooks/useLoader";
import { z } from "src/lib";
import { ContextOperacionNuevo, ContextOperacionNuevoType } from "../../NuevoSistema";
import { useSubmitOperacion } from "../../hooks/useSubmitOperacion";
import { HttpWRC } from "./api";
import { DetallePutFields } from "./api/detalle-fields";
import { SeccionWRCDatosOperacion } from "./components";
import SeccionWRCDetalleNuevo from "./components/SeccionWRCDetalleNuevo";
import { OperacionWRCFields } from "./types/fields";

// TODO: hook de forms, le pasas schema, te devuelve meotod, fields


export const DetalleProvisionalFields = {
  IdProvisional: "idProvisional",
  CodOperacionTipo: "codOperacionTipo",
  Excepcion: "operacionExcepcion",
} as const

export const detalleProvisional = z
  .object({
    [DetalleProvisionalFields.IdProvisional]: z.string(),
    [DetalleProvisionalFields.CodOperacionTipo]: z.number(),
    [DetalleProvisionalFields.Excepcion]: z.string()
  })

export type DetalleProvisional = z.infer<typeof detalleProvisional>

const schemaNuevaOperacion = z.object({
  [OperacionWRCFields.CodSectorComercial]: z.number(),
  [OperacionWRCFields.NroComitente]: z.string(),
  [OperacionWRCFields.DenominacionComitente]: z.string(),
  [OperacionWRCFields.Observaciones]: z.string().optional(),
  [OperacionWRCFields.FechaEmision]: z.date(),
  [OperacionWRCFields.FechaVencimiento]: z.date()
}).refine(
  schema => (

    // No uso computed key porque: https://github.com/microsoft/TypeScript/issues/10530
    schema.fechaVencimiento ? (schema.fechaVencimiento.getTime() >= schema.fechaEmision.getTime()) : true
  ),
  {
    message: 'La fecha de vencimiento debe ser mayor a la fecha de emisión.',
    path: [OperacionWRCFields.FechaVencimiento]
  }
)

// TODO: unir con actualizar, son iguales
type SchemaNuevaOperacion = z.infer<typeof schemaNuevaOperacion>

type NuevoSistemaWRCreditoProps = {
  codSistemaPrincipal: number
}

export const NuevoSistemaWRCredito = (props: NuevoSistemaWRCreditoProps) => {
  const { submitOperacion } = useSubmitOperacion();

  const [detallesProvisionales, setDetallesProvisionales] = useState<DetalleProvisional[]>([])

  const formMethods = useForm<SchemaNuevaOperacion>({
    resolver: zodResolver(schemaNuevaOperacion),
    defaultValues: {
      [OperacionWRCFields.FechaEmision]: new Date()
    }
  })

  const alCrearOperacionWRC = useCallback((data: SchemaNuevaOperacion, selected: number) => {
    if (!detallesProvisionales.length) {
      toast.error("Debe cargar por lo menos un detalle para enviar la operación.");
      
      return;
    }

    const payload = {
      ...data,
      [OperacionWRCFields.Detalles]: detallesProvisionales.map(dt => ({
        [DetallePutFields.CodOperacionTipo]: dt[DetalleProvisionalFields.CodOperacionTipo],
        [DetallePutFields.Excepcion]: dt[DetalleProvisionalFields.Excepcion]
      })),
      [OperacionWRCFields.BitEnvio]: selected !== 1,
      [OperacionWRCFields.CodPais]: props.codSistemaPrincipal
    };

    submitOperacion(payload, {
      apiCall: HttpWRC.post,
      successMessage: 'Guardado correctamente.',
      errorMessage: 'Error al guardar.'
    });
  }, [detallesProvisionales, props.codSistemaPrincipal, submitOperacion]);

  const { setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  useEffect(() => {
    const onSend = () => formMethods.handleSubmit(data => alCrearOperacionWRC(data, 2))
    setSendPromise(onSend)
  }, [formMethods, alCrearOperacionWRC])

  useEffect(() => {
    console.log(detallesProvisionales)
  }, [detallesProvisionales])

  return (
    <Box>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <SeccionWRCDatosOperacion
            formMethods={formMethods}
            codSistemaPrincipal={props.codSistemaPrincipal}
            codSistema={codSistema}
            nuevo
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionWRCDetalleNuevo
            idPais={props.codSistemaPrincipal}
            detallesProvisionales={detallesProvisionales}
            setDetallesProvisionales={setDetallesProvisionales}
          />
        </Grid>
      </Grid>
    </Box>
  )
}
